import { hrmsWithPath } from "../../services/http/api/rest";

const rest = hrmsWithPath("/v1/");
const attendance = {
    admin: {
        //to get check-in details
        punchList: (startDate: string, endDate: string, pageNumber: number, pageSize: number) =>
            rest.get('check-ins', {}, {
                "start-date": startDate,
                "end-date": endDate,
                "page-number": pageNumber,
                "page-size": pageSize
            }),
        getEmployeePunches: (employeeId: string, startDate: string, endDate: string, pageNumber: number, pageSize: number) =>
            rest.get('{{employeeId}}/check-ins', {employeeId}, {
                "start-date": startDate,
                "end-date": endDate,
                "page-number": pageNumber,
                "page-size": pageSize
            }),

        //to get admin-attendance-card details
        list: (page: number, size: number, startDate?: string, endDate?: string, employeeId?: string, sortField?: any, sortDirection?: any,status?:string) =>
            rest.get('attendance', {}, {
                "page-number": page,
                "page-size": size,
                "start-date": startDate,
                "end-date": endDate,
                'sort-by': sortField,
                'sort-direction': sortDirection,
                'employee-id': employeeId,
                'status':status
            }),
        //to get admin-attendance-card count
        count: (date: string) => rest.get('attendance/count', {}, {
            date: date
        }),
        //to get attendance-chart data
        chartData: () => rest.get('attendance/analysis', {}, {})
    },
    employee: {
        punchList: (employeeId: string, pageNumber: number, pageSize?: number, startDate?: string, endDate?: string, sortField?: string, sortDirection?: string) =>
            rest.get(`{{employeeId}}/check-ins`, {employeeId}, {
                "start-date": startDate,
                "end-date": endDate,
                "page-number": pageNumber,
                "page-size": pageSize,
                'sort-by': sortField,
                'sortDirection': sortDirection
            }),
        list: (employeeId: string, page: number, size?: number, startDate?: string, endDate?: string, sortField?: any, sortDirection?: any,
        status?: string) =>
            rest.get(`attendance`, {employeeId}, {
                "employee-id": employeeId,
                "page-number": page,
                "page-size": size,
                "start-date": startDate,
                "end-date": endDate,
                'sort-by': sortField,
                'sortDirection': sortDirection,
                'status':status
            }),
        getAttendanceSummary: (empId: string, year?: number) => rest.get(`attendance/{{empId}}/summary`, {empId}, {
            "year": year
        }),
    },
    supervisor: {
        list: (page: number, size: number, startDate?: string, endDate?: string, employeeId?: string, sortField?: any, sortDirection?: any,status?:string) =>
            rest.get(`attendance`, {}, {
                "include-reportees": !employeeId,
                "employee-id": employeeId,
                "page-number": page,
                "page-size": size,
                "start-date": startDate,
                "end-date": endDate,
                'sort-by': sortField,
                'sortDirection': sortDirection,
                'status':status
            }),
        getTeamSummary: () => rest.get('attendance/team/summary', {}, {}),
    }
}

export default attendance;
